import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/api-url-helper';
import { CommonService } from 'src/app/services/common/common.service';
import { AddEventConfirmationDialogComponent } from '../add-event-confirmation-dialog/add-event-confirmation-dialog.component';
import { MatPaginator } from '@angular/material/paginator';
import { OrderCartDialogComponent } from '../order-cart-dialog/order-cart-dialog.component';
import { currencyIcons, dateformat } from 'src/app/models/commonModel';

@Component({
    selector: 'app-add-event-dialog',
    templateUrl: './add-event-dialog.component.html',
    styleUrls: ['./add-event-dialog.component.scss'],
    standalone: false
})
export class AddEventDialogComponent implements OnInit {

  // Common Properties
  customerId: any;
  eventList: any = [];
  sortColumn: string = '';
  sortOrder: string = '';
  eventStartDate: any;
  eventEndDate: any;
  searchString = '';
  pageNumber: any = 1;
  pageSize: any = 10;
  selectedIds: any[] = [];
  selectFilterIds: any = null;
  @ViewChild(MatPaginator) paginator: any;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  currentPage: number = 0;
  totalrecord: number = 0;
  fromAddOrder: boolean = false;
  dateFormat: any;
  currency: any;
  isEventDataAvailable: boolean = true;

  constructor(
    private dialogRef: MatDialogRef<AddEventDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private api: ApiUrlHelper,
    private dialog: MatDialog) {
    this.customerId = data.customerId;
    this.fromAddOrder = data.fromAddOrder;
  }

  ngOnInit(): void {
    this.dateFormat = dateformat;
    this.currency = currencyIcons;
    this.getEventList();
  }

  cancel() {
    this.dialogRef.close(false);
  }

  getEventList() {
    this.isEventDataAvailable = true;
    let api = this.api.apiUrl.Event.GetEventListForCustomer;
    this.spinner.show();
    let getAboutListModel = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      SortColumn: this.sortColumn,
      SortOrder: this.sortOrder,
      StrSearch: this.searchString,
      OffSet: this.commonService.getTimeZone(),
      customerId: this.customerId,
      filter: this.selectFilterIds
    };
    this.commonService.doPost(api, getAboutListModel).subscribe({
      next: (response) => {
        if (response.success) {
          if (this.searchString == '' && response.data.length == 0) {
            this.isEventDataAvailable = false
          }
          this.eventList = response.data;
          this.totalrecord = response.data[0]?.totalRecords || 0;
          this.eventList = response.data;
          this.spinner.hide();
        } else {
          this.toaster.error(response.message);
          this.spinner.hide();
        }
      },
      error: (error) => {
        this.spinner.hide();
      }
    });
  }

  eventAddConfirmation(eventData: any) {
    const dialogRef = this.dialog.open(AddEventConfirmationDialogComponent, {
      width: '470px',
      disableClose: true,
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        var data = {
          customerId: this.customerId,
          event: eventData
        }
        this.dialogRef.close(data);
      }
    })
  }

  // Page Change Event happen
  pageChanged(event: any) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getEventList();
  }

  //For Sort Data event happen
  sortData(event: any) {
    this.sortOrder = event.direction;
    this.sortColumn = event.active;
    this.getEventList();
  }

  eventImageErrorHandler(eventData: any) {
    eventData.images = '../../../../../assets/img/default-event.svg';
  }

  applyFilter(event) {
    if ((event.target.value == '') || (event.key && event.key === "Enter" && event.target.value != '')) {
      this.getEventList();
    }
  }

  clearSearch() {
    this.searchString = '';
    this.getEventList();
  }
}